import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SquareIcon(props: IconProps) {
    return <Icon {...props} iconKey={"square"}/>
}
